import { Autocomplete, Box, Button, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { CrisRequest } from 'app/model/cris-request';
import { crisRequestService } from 'app/services/cris-request.service';

import { Formatters } from 'app/utils/formatters';

interface CrisDeleteProps {
    request: CrisRequest;
    onDelete: (target?: CrisRequest) => void;
}

export const CrisDelete: React.FC<CrisDeleteProps> = (props) => {
    const [target, setTarget] = useState<CrisRequest>();
    const [allTargets, setAllTargets] = useState<CrisRequest[]>([]);

    const handleChange = (event: unknown, newValue: CrisRequest | null): void => {
        setTarget(newValue ?? undefined);
    };

    useEffect(() => {
        if (!props.request.brand) {
            return;
        }
        crisRequestService.listAll({ filters: { brand: props.request.brand.id } }).subscribe((requests) => {
            const filteredRequests = requests.filter((request) => request.id !== props.request.id);
            setAllTargets(filteredRequests);
        });
    }, [props.request]);

    if (!props.request.brand) {
        return <Typography> This request is not linked to a brand, deletion not possible !</Typography>;
    }

    return (
        <>
            <Typography variant='body1' mb={2}>
                This page allows you to delete current CRIS request record from the system.
                <br />
                All the data associated with this request (comments, seam requests, etc.) will be migrated into the
                target you select below.
            </Typography>
            <Autocomplete
                disablePortal
                id='combo-box-demo'
                options={allTargets}
                sx={{ width: '100%' }}
                renderInput={(params) => <TextField {...params} label='Cris Request' />}
                getOptionLabel={(val) =>
                    `${val.brand?.name ?? ''} - ${Formatters.crisRequestId(val.id)} (${val.currentPlace})`
                }
                onChange={handleChange}
            />
            <Box mt={1}>
                <Box display='flex' justifyContent='flex-end'>
                    <Button variant='contained' size='small' color='primary' onClick={() => props.onDelete(target)}>
                        Delete
                    </Button>
                </Box>
            </Box>
        </>
    );
};
